import axios from '../../axios'

// 筛选该类型通过审核的信息
export const list = (data) => {
  return axios({
    url: '/system/sysInfo/select',
    method: 'post',
    data
  })
};

// 查看
export const view = (data) => {
  return axios({
    url: '/system/sysInfo/view',
    method: 'post',
    data
  })
};
// 获取附件
export const getAttachByIds = (data) => {
  return axios({
    url: '/system/sysAttach/getAttachByIds',
    method: 'post',
    data
  })
};




// WEBPACK FOOTER //
// ./src/http/moudules/sys/infoMenu.js